import {
  AddressBasedTemplateDetailPage,
  type AddressBasedTemplatePageConfig,
} from "../check-arguments-templates-shared";

const config: AddressBasedTemplatePageConfig = {
  apiPathPrefix: "bankruptcy",
  settingsPathPrefix: "bankruptcy-templates",
  templateLabel: (t) => t("Bankruptcy"),
  testIdPrefix: "bankruptcy-template",
};

export function BankruptcyTemplateDetailPage() {
  return <AddressBasedTemplateDetailPage config={config} />;
}
